var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.53484H2V9.53484H11V7.53484ZM11 15.5348H2V17.5348H11V15.5348ZM16.34 11.5348L12.8 7.99484L14.21 6.58484L16.33 8.70484L20.57 4.46484L22 5.87484L16.34 11.5348ZM16.34 19.5348L12.8 15.9948L14.21 14.5848L16.33 16.7048L20.57 12.4648L22 13.8748L16.34 19.5348Z",
    fill: "#FF832B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowListIcon);
export default __webpack_public_path__ + "static/media/show-list-icon.b87b6af2713f100e5a52f1394fabddbe.svg";
export { ForwardRef as ReactComponent };